<template>
  <div>
    <div class="min-vh-100">
      <h1
        class="
          text-center text-sm-left
          mb-0 mb-sm-3
          header-main
          text-uppercase
          header-inline
        "
      >
        MESSAGE REPORT
      </h1>
      <b-container class="px-0">
        <b-row class="no-gutters px-0">
          <b-col xl="6" class="text-center text-sm-left mb-3 mb-sm-0">
            <label class="mx-2 display-sm-none">Select date : </label>
            <b-dropdown
              id="dropdown-form"
              variant="outline"
              ref="dropdowndate"
              :text="dateType"
              class="bg-white m-2 p-0 dropdown-date-custom"
              menu-class="w-100"
            >
              <b-row class="no-gutters p-3">
                <b-col class="dropdown-date-custom-text">
                  Select Date <span>(select only last 30 days)</span>
                </b-col>
                <!-- <b-col class="text-md-right" sm="6">
                  <a @click="resetDate"> Reset </a>
                </b-col> -->
              </b-row>
              <datetime
                type="datetime"
                v-model="filter.DateStart"
                :min-datetime="minDate"
                class="date-picker-input px-3"
                value-zone="Asia/Bangkok"
                placeholder="dd/mm/yyyy (hh:mm)"
              ></datetime>
              <div class="text-center">-</div>
              <datetime
                type="datetime"
                v-model="filter.DateEnd"
                :min-datetime="minDate"
                class="date-picker-input px-3"
                value-zone="Asia/Bangkok"
                placeholder="dd/mm/yyyy (hh:mm)"
              ></datetime>
              <div class="p-3">
                <span class="text-danger" v-if="datetimeCheckError">{{
                  datetimeCheckError
                }}</span>
                <b-button
                  class="p-2 w-100 button-color"
                  size="sm"
                  @click="onClickChooseDate"
                  >SUBMIT</b-button
                >
              </div>
            </b-dropdown>
          </b-col>
          <b-col xl="6" class="text-left text-xl-right">
            <b-button @click="exportFallbackExcel" class="export-button m-2">
              <div>
                <font-awesome-icon icon="file-export" />
                <span class="ml-2"> EXPORT FALLBACK EXCEL </span>
              </div>
            </b-button>
            <b-button @click="exportExcel" class="export-button m-2">
              <div>
                <font-awesome-icon icon="file-export" />
                <span class="ml-2"> EXPORT TO EXCEL </span>
              </div>
            </b-button>
            <b-dropdown
              id="dropdown-filter"
              variant="outline"
              right
              ref="dropdownfilter"
              class="m-2 filter-custom"
              no-flip
            >
              <template v-slot:button-content>
                <font-awesome-icon icon="filter" class="mr-2" />FILTER
              </template>
              <div>
                <p class="mb-2 dropdown-date-custom-text">Channel Type</p>
              </div>
              <b-dropdown-divider></b-dropdown-divider>
              <div>
                <div class="input-flex-container">
                  <div
                    class="w-100 text-center my-2"
                    v-if="isLoadingChannelType"
                  >
                    <b-spinner small></b-spinner>
                  </div>
                  <div v-else>
                    <b-form-checkbox-group
                      v-model="filter.ChannelType"
                      :options="messageChannels"
                      class="mb-3"
                      value-field="id"
                      text-field="name"
                    ></b-form-checkbox-group>
                  </div>
                </div>
                <div class="d-flex align-items-center">
                  <p class="mb-0 mr-2 dropdown-date-custom-text">
                    Status Code :
                  </p>
                  <b-form-select
                    v-model="filter.StatusCode"
                    :options="statusCodeLists"
                    size="sm"
                    class="mt-0 w-50"
                  ></b-form-select>
                </div>

                <div>
                  <b-input-group class="mt-3">
                    <b-form-input
                      v-model="filter.Search"
                      placeholder="keyword search"
                      @keydown.enter="onClickSearch"
                    />
                    <b-input-group-append>
                      <b-button @click="onClickSearch" class="search-button">
                        <font-awesome-icon icon="search" />
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </div>
                <div class="mt-4">
                  <b-button class="w-100 submit-button" @click="onClickSearch">
                    <div>
                      <span> Search </span>
                    </div>
                  </b-button>
                </div>
              </div>
            </b-dropdown>
          </b-col>
        </b-row>
      </b-container>
      <div class="mt-3 bg-white-border p-3">
        <div class="container-line mb-4">
          <h2 class="font-weight-bold">Overview</h2>
          <b-container class="px-0" fluid>
            <b-row class="no-gutters my-4">
              <b-col lg="3" sm="12" class="mb-3 mb-lg-0">
                <div
                  class="
                    container-borderleft
                    overview-padding
                    mr-lg-2 mr-0
                    h-100
                  "
                >
                  <div class="mb-4">
                    <font-awesome-icon icon="map" class="mr-2" />
                    <span class="overview-font-size">Current Plan</span>
                  </div>
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <span class="unit-font text-break">Unit (-)</span>
                    <h1 class="text-break overview-number">
                      {{ currentplan ? currentplan : "-" }}
                    </h1>
                  </div>
                </div>
              </b-col>
              <b-col lg="3" sm="12" class="mb-3 mb-lg-0">
                <div
                  class="
                    container-borderleft
                    overview-padding
                    mr-lg-2 mr-0
                    h-100
                  "
                >
                  <div class="mb-4">
                    <font-awesome-icon icon="user-friends" class="mr-2" />
                    <span class="overview-font-size">MAU (AS OF TODAY)</span>
                  </div>
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <span class="unit-font text-break">Unit (People)</span>
                    <h1 class="text-break overview-number">
                      {{ mau | numeral("0,0.00") }}
                    </h1>
                  </div>
                </div>
              </b-col>
              <b-col lg="3" sm="12" class="mb-3 mb-lg-0">
                <div
                  class="
                    container-borderleft
                    overview-padding
                    mr-lg-2 mr-0
                    h-100
                  "
                >
                  <div class="mb-4">
                    <font-awesome-icon icon="image" class="mr-2" />
                    <span class="overview-font-size">Visual Search</span>
                  </div>
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <span class="unit-font text-break">Unit (Image)</span>
                    <h1 class="text-break overview-number">
                      {{ imageCount | numeral("0,0") }}/{{
                        requestImage | numeral("0,0")
                      }}
                    </h1>
                  </div>
                </div>
              </b-col>
              <b-col lg="3" sm="12" class="mb-3 mb-lg-0">
                <div class="container-borderleft overview-padding mb-0 h-100">
                  <div class="mb-4">
                    <font-awesome-icon icon="comment-alt" class="mr-2" />
                    <span class="overview-font-size">Message/Sec</span>
                  </div>
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <span class="unit-font text-break">Unit (message)</span>
                    <h1 class="text-break overview-number">
                      {{ messagePerSec | numeral("0,0.00") }}
                    </h1>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-container>
        </div>
        <div>
          <h2 class="font-weight-bold">Message Log</h2>
          <b-row class="main-theme md-1 no-gutters my-3">
            <b-col class="mt-4 w-100">
              <b-table
                responsive
                striped
                hover
                class="table-list"
                :items="messageLists"
                :fields="fields"
                :busy="isBusy"
                show-empty
                empty-text="ไม่พบข้อมูล"
              >
                <template v-slot:table-busy>
                  <div class="text-center text-black my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong class="ml-2">Loading...</strong>
                  </div>
                </template>
                <template v-slot:cell(createTime)="data">
                  <span>
                    {{
                      new Date(data.item.createTime) | moment($formatDateTime)
                    }}
                  </span>
                </template>
                <template v-slot:cell(message)="data">
                  <span>
                    {{ data.item.message ? data.item.message : "-" }}
                  </span>
                </template>
                <template v-slot:cell(messageId)="data">
                  <span>
                    {{ data.item.messageId ? data.item.messageId : "-" }}
                  </span>
                </template>
                <template v-slot:cell(sendTime)="data">
                  <span>
                    {{ new Date(data.item.sendTime) | moment($formatDateTime) }}
                  </span>
                </template>
                <template v-slot:cell(sender)="data">
                  <span>
                    {{ data.item.sender ? data.item.sender : "-" }}
                  </span>
                </template>
                <template v-slot:cell(receiver)="data">
                  <span>
                    {{ data.item.receiver ? data.item.receiver : "-" }}
                  </span>
                </template>

                <template v-slot:cell(statusCodeName)="data">
                  <span>
                    {{
                      data.item.statusCodeName ? data.item.statusCodeName : "-"
                    }}
                  </span>
                </template>
                <template v-slot:cell(waitTime)="data">
                  <span>
                    {{ data.item.waitTime ? data.item.waitTime : "-" }}
                  </span>
                </template>
                <template v-slot:cell(id)="data">
                  <div class="d-flex justify-content-center">
                    <router-link
                      :to="`/message-log/details/${data.item.id}/${data.item.collection}`"
                    >
                      <u>Details</u>
                    </router-link>
                  </div>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <b-row class="no-gutters px-3 px-sm-0">
            <b-col
              class="
                form-inline
                justify-content-center justify-content-sm-between
              "
            >
              <div v-if="rows > 0" class="my-auto">
                Showing {{ startPage | numeral("0,0") }} to {{ endPage | numeral("0,0") }} of {{ rows | numeral("0,0") }} entires
              </div>
              <div v-else class="my-auto">{{ rows }} entire</div>
              <div class="d-sm-flex m-3">
                <b-pagination
                  v-model="filter.pageNo"
                  :total-rows="rows"
                  :per-page="filter.perPage"
                  class="m-md-0"
                  @change="pagination"
                  align="center"
                ></b-pagination>
              </div>
            </b-col>
          </b-row>
        </div>
        <ModalLoading ref="modalLoading" :text="msgModal" :hasClose="false" />
        <ModalAlert
          ref="modalAlert"
          :text="modalMessage"
          v-on:hadleModalAlertClose="hadleModalAlertClose"
        />
        <ModalAlertError ref="modalAlertError" :text="modalMessage" />
      </div>
    </div>
  </div>
</template>

<script>
import ModalLoading from "@/components/modal/alert/ModalLoading";
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import moment from "moment";

export default {
  name: "MessageLog",
  components: {
    ModalLoading,
    ModalAlert,
    ModalAlertError,
  },
  data() {
    return {
      msgModal: null,
      modalMessage: "",
      minDate: moment(new Date())
        .subtract(1, "months")
        .format(),
      startDate: "",
      isLoadingChannelType: false,
      dateType: "Select Date",
      endDate: "",
      datetimeCheckError: null,
      messageLists: [],
      messageChannels: [],
      statusCodeLists: [{value:0,text:"All"},{value:1,text:"Success"},{value:2,text:"Fail"}],
      messagePerSec: 0,
      mau: 0,
      isBusy: false,
      rows: 0,
      startPage: 1,
      endPage: 10,
      currentplan: 0,
      requestImage: 0,
      imageCount: 0,
      fields: [
        {
          key: "createTime",
          label: "Time",
          class: "w-100px",
        },
        {
          key: "message",
          label: "Message/Image",
          class: "w-100px",
        },
        {
          key: "messageId",
          label: "Message ID",
          class: "w-100px",
        },
        {
          key: "sendTime",
          label: "Send Time",
          class: "w-100px",
        },
        {
          key: "sender",
          label: "From",
          class: "w-100px",
        },
        {
          key: "channelSender",
          label: "From Channel",
          class: "w-100px",
        },
        {
          key: "receiver",
          label: "To",
          class: "w-100px",
        },
        {
          key: "channelReceiver",
          label: "To Channel",
          class: "w-100px",
        },
        {
          key: "statusCodeName",
          label: "Status",
          class: "w-100px",
        },
        {
          key: "waitTime",
          label: "Response Time",
          class: "w-100px",
        },
        {
          key: "id",
          label: "Action",
        },
      ],
      filter: {
        DateStart: moment()
          .startOf("day")
          .format(),
        DateEnd: moment(new Date()).format(),
        pageNo: 1,
        perPage: 10,
        Search: "",
        ChannelType: [1, 2, 3],
        StatusCode: 0
      },
    };
  },
  created: async function() {
    await this.getAllData();
    await this.getMessageChannelType();
    this.getShowingPage(1);
  },
  methods: {
    getAllData: async function() {
      await this.getMessageLog();
      await this.getMessagePerSec();
      await this.getMAU();
      await this.getCurrentPlan();
      await this.getVisualSearch();
    },
    getMessageLog: async function() {
      this.isBusy = true;
      await this.axios
        .post(`${this.$baseUrl}/messagelog/GetMessageLog`, this.filter)
        .then((data) => {
          if (data.result === 1) {
            this.messageLists = data.detail.messageList;
            this.rows = data.detail.count;
            this.isBusy = false;
          }
        });
    },
    getMessageChannelType: async function() {
      this.isLoadingChannelType = true;
      await this.axios(`${this.$baseUrl}/masterdata/MessageChannelType`)
        .then((data) => {
          if (data.result === 1) {
            this.messageChannels = data.detail;
            this.isLoadingChannelType = false;
          }
        })
        .catch((error) => {
          this.messageChannel = [];
          this.isLoadingChannelType = false;
        });
    },
    getMessagePerSec: async function() {
      await this.axios(`${this.$baseUrl}/messagelog/GetMsgPerSec`).then(
        (data) => {
          if (data.result === 1) {
            this.messagePerSec = data.detail;
          }
        }
      );
    },
    getMAU: async function() {
      await this.axios
        .post(`${this.$baseUrl}/messagelog/GetMAU`, this.filter)
        .then((data) => {
          if (data.result === 1) {
            this.mau = data.detail;
          }
        });
    },
    getCurrentPlan: async function() {
      await this.axios(`${this.$baseUrl}/CurrentPlan`).then((data) => {
        if (data.result === 1) {
          this.currentplan = data.detail.planName;
          this.requestImage = data.detail.requestImage;
        }
      });
    },
    getVisualSearch: async function() {
      await this.axios(`${this.$baseUrl}/messagelog/GetImageCount`).then(
        (data) => {
          if (data.result === 1) {
            this.imageCount = data.detail;
          }
        }
      );
    },
    onClickSearch: async function() {
      this.$refs.dropdownfilter.hide(false);
      await this.getAllData();
    },
    onClickChooseDate: async function() {
      if (this.filter.DateStart && this.filter.DateEnd) {
        this.datetimeCheckError = null;
        this.$refs.dropdowndate.hide(false);
        await this.getAllData();
        this.getShowingPage(1);
      } else {
        this.datetimeCheckError = "Please Choose Start and End";
        return;
      }
    },
    pagination(Page) {
      this.filter.pageNo = Page;
      this.getMessageLog();
      this.getShowingPage(Page);
    },
    getShowingPage(Page) {
      const totalRow = this.rows;
      this.startPage = (Page - 1) * this.filter.perPage + 1;
      if (Page * this.filter.perPage <= totalRow) {
        this.endPage = Page * this.filter.perPage;
      } else {
        this.endPage = totalRow;
      }
    },
    hadleModalAlertClose() {
      this.$refs.modalAlert.hide();
    },
      async exportFallbackExcel() {
      this.$refs.modalLoading.show();
      this.msgModal = "In progress";
      try {
        const body = {
          DateStart: this.filter.DateStart,
          DateEnd: this.filter.DateEnd,
        };
        await this.axios
          .post(`${this.$baseUrl}/messagelog/GetFallbackExcel`, body)
          .then((data) => {
            if (data.result === 1) {
              this.modalMessage = `ทำการส่งไฟล์สำเร็จ`;
              this.$refs.modalLoading.hide();
              this.$refs.modalAlert.show();
            } else {
              this.modalMessage = "ทำการส่งไฟล์ไม่สำเร็จ";
              this.$refs.modalLoading.hide();
              this.$refs.modalAlertError.show();
            }
          });
      } catch (error) {
        console.error(error);
        this.modalMessage = "ทำการส่งไฟล์ไม่สำเร็จ";
        this.$refs.modalLoading.hide();
        this.$refs.modalAlertError.show();
      }
    },
    async exportExcel() {
      this.$refs.modalLoading.show();
      this.msgModal = "In progress";
      try {
        const body = {
          DateStart: this.filter.DateStart,
          DateEnd: this.filter.DateEnd,
          Search: this.filter.Search,
          StatusCode: this.filter.StatusCode,
          ChannelType: this.filter.ChannelType,
        };
        await this.axios
          .post(`${this.$baseUrl}/messagelog/GetMessageLogExcel`, body)
          .then((data) => {
            if (data.result === 1) {
              this.modalMessage = `ทำการส่งไฟล์สำเร็จ`;
              this.$refs.modalLoading.hide();
              this.$refs.modalAlert.show();
            } else {
              this.modalMessage = "ทำการส่งไฟล์ไม่สำเร็จ";
              this.$refs.modalLoading.hide();
              this.$refs.modalAlertError.show();
            }
          });
      } catch (error) {
        console.error(error);
        this.modalMessage = "ทำการส่งไฟล์ไม่สำเร็จ";
        this.$refs.modalLoading.hide();
        this.$refs.modalAlertError.show();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.break-all {
  word-break: break-all;
}

.textbody {
  width: 400px;
  word-break: break-all;
}

.submit-button {
  background-color: #5b57a5;
  color: white;
  border-radius: 4px;
}

.unit-font {
  font-size: 14px;
  color: #575757;
}

.container-borderleft {
  border-left: 5px solid #7160c4;
  background-color: #e2dff3;
}

.padding-rem {
  padding: 0.5rem 1.25rem;
}

.dropdown-date-custom {
  width: 60%;
  border-radius: 3px;
}

.dropdown-date-custom-text {
  color: #575757 !important;
}

.search-button {
  background-color: #ffffff;
  text-align: center !important;
  border-left: 0;
  color: #575757;
}

.button-color {
  background-color: #8f20c6;
  text-align: center !important;
  color: white;
}

.container-line {
  border-bottom: 1px solid #bebebe;
}

a {
  text-decoration: underline;
  color: #7160c4;
}

a:hover {
  cursor: pointer;
}

label {
  color: #8b8b8b;
}

.input-flex-container {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.overview-padding {
  padding: 16px;
  @media screen and (max-width: 1240px) and (min-width: 990px) {
    padding: 16px 8px;
  }
}

.overview-number {
  font-size: 27px;
  @media screen and (max-width: 1240px) and (min-width: 990px) {
    font-size: 24px;
  }
}

.overview-font-size {
  font-size: 16px;
  @media screen and (max-width: 1240px) and (min-width: 990px) {
    font-size: 14px;
  }
}

.export-button {
  background-color: #0d1731;
  color: #ffffff !important;
  min-width: 150px;
  font-weight: bold;
  transition: 0.3s;
  border-radius: 4px;
  border-color: #0d1731;
}

.display-sm-none {
  @media screen and (max-width: 657px) {
    display: none;
  }
}

.header-inline {
  display: inline;
  @media screen and (max-width: 1200px) {
    display: block;
  }
}
</style>
